/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { object } from 'prop-types';
import styles from './social-media-links.module.scss';

const FRAME_HEIGHT = '436';
const FRAME_WIDTH = '626';

const Pinterest = ({ props = {} }) => {
  const {shareable, href} = props
  

  if (!href) {
    return null;
  }
  const onPinterestClick = () => {
    window.open(href, 'pinterest_share', `width=${FRAME_WIDTH},height=${FRAME_HEIGHT}`)
  }

  return (
    <a
      data-testid="pinterest-element"
      className=""
      href={href}
      title="Pinterest"
      target="_blank"
      rel="nofollow"
      onClick = {shareable && onPinterestClick}
    >
      <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" style={{ paddingRight: '5px'  }}>
        <g id="MW---Katie" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="blog/author-bio/v3" transform="translate(-60.000000, -542.000000)" fill="#666666" fillRule="nonzero">
            <g id="Organism-/-ALP-/-Card-/-Project-Guide-Initial-Copy-7" transform="translate(10.000000, 282.000000)">
              <g id="social" transform="translate(17.000000, 260.000000)">
                <g id="Path-2" transform="translate(33.000000, 0.000000)">
                  <path d="M12.5182741,3.55271368e-15 C5.60440249,3.55271368e-15 0,5.590625 0,12.4864583 C0,17.7770833 3.29769015,22.2958333 7.95497264,24.1135417 C7.8453281,23.125 7.74717013,21.6104167 7.99778622,20.53125 C8.22647341,19.5552083 9.46597886,14.3260417 9.46597886,14.3260417 C9.46597886,14.3260417 9.09109895,13.5760417 9.09109895,12.4708333 C9.09109895,10.7385417 10.100873,9.43854167 11.3549977,9.43854167 C12.4242931,9.43854167 12.9401445,10.2395833 12.9401445,11.196875 C12.9401445,12.26875 12.2582599,13.8708333 11.9042647,15.3552083 C11.606658,16.5979167 12.5308049,17.6104167 13.7577795,17.6104167 C15.9799089,17.6104167 17.6924523,15.271875 17.6924523,11.8947917 C17.6924523,8.91458333 15.5381981,6.82291667 12.4629297,6.82291667 C8.90209264,6.82291667 6.8146694,9.49166667 6.8146694,12.2385417 C6.8146694,13.3145833 7.22609749,14.4708333 7.74299319,15.09375 C7.84637233,15.21875 7.85994737,15.328125 7.83175306,15.453125 C7.73777202,15.84375 7.52579257,16.7020833 7.48297899,16.8729167 C7.4276346,17.1072917 7.30337079,17.1552083 7.06424126,17.0447917 C5.50311182,16.3260417 4.52362057,14.046875 4.52362057,12.2052083 C4.52362057,8.271875 7.39317489,4.65104167 12.7939518,4.65104167 C17.1358757,4.65104167 20.5129276,7.74166667 20.5129276,11.8625 C20.5129276,16.1697917 17.7906103,19.6354167 14.0042187,19.6354167 C12.7365189,19.6354167 11.5460925,18.9802083 11.124222,18.1989583 L10.342091,21.165625 C10.0611921,22.2541667 9.2936803,23.615625 8.77782883,24.4427083 C9.95050332,24.8020833 11.1858318,25 12.4848586,25 C19.3841109,25 25,19.4114583 25,12.5135417 C25,5.61458333 19.3841109,0.0270833333 12.4848586,0.0270833333 L12.5182741,3.55271368e-15 Z" id="Path" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </a>
  );
};

Pinterest.propTypes = {
  props: object.isRequired
};

Pinterest.displayName = 'Pinterest';

export { Pinterest };
